import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="49" height="49" viewBox="0 0 49 49" fill="none">
      <g filter="url(#filter0_f_1508_2375)">
        <circle cx="24.7548" cy="24.6327" r="5.71429" fill="#F59C53" />
      </g>
      <defs>
        <filter
          id="filter0_f_1508_2375"
          x="0.754814"
          y="0.632744"
          width="47.9999"
          height="48.0001"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="9.14286" result="effect1_foregroundBlur_1508_2375" />
        </filter>
      </defs>
    </svg>
  );
};

export default Icon;
